// extracted by mini-css-extract-plugin
module.exports = {"container":"letterBox_container__12axo","wrapper":"letterBox_wrapper__1S-C2"};